<ng-container *transloco="let t">

    <div class="admin-card">
        <app-admin-actions-header [isPdfVisible]="false" [isXlsVisible]="false">
            <div slot="leadingWidgets" class="d-flex flex-column flex-md-row">
            </div>
            <div slot="trailingWidgets">
                @if (!disableEditing) {
                <div>
                    <app-rounded-button [label]="t('league.scoring.categorization.add')" (onClick)="onAdd()" [btnClass]="'rounded-button--solid'"
                                        [isDisabled]="!hideForm"><i class="bi bi-plus-circle pe-2"></i>
                    </app-rounded-button>
                </div>
                }
            </div>
        </app-admin-actions-header>


        @if (categorizations?.length ?? 0 > 0) {
        <div class="table-responsive">
          <table class="table dark-header table-last-row-no-border">
            <thead>
            <tr>
        <th>
        {{ t('app.common.item.name') }}
        </th>
        <th>
        {{ t('league.scoring.categorization.individual.config') }}
        </th>
        <th>
        {{ t('league.scoring.categorization.group.config') }}
        </th>
        <th>
        {{ t('league.scoring.categorization.types.count') }}
        </th>
         <th>
        {{ t('app.common.created') }}
        </th>
        <th>
        {{ t('app.common.modified') }}
        </th>
        <th class="text-end more-column-width"></th>
    </tr>
    </thead>
    <tbody>
    @for (categorization of categorizations; track categorization) {
        <tr>
            <td class="center-align">
                {{categorization.name ?? "-"}}
            </td>
            <td class="center-align">
                {{categorization.individualScoringConfig?.name ?? "-"}}
            </td>
            <td class="center-align">
                {{categorization.groupScoringConfig?.name ?? "-"}}
            </td>
            <td class="center-align">
                {{ categorization.types?.length ?? 0}}
                @if (invalidCategorizations.has(categorization.id!)) {
                <i class="bi bi-info-circle info-icon ps-2 error" ngbTooltip="{{ t('league.scoring.categorization.types.assignedRaces.error') }}"
                   placement="left"></i>
                }
            </td>
            <td class="center-align">
                {{categorization.created ?? '' | localizedDate:'short'}}
            </td>
            <td class="center-align">
                {{categorization.modified ?? '' | localizedDate:'short'}}
            </td>
            <td class="text-end center-align">
                <div ngbDropdown class="dropdown dropdown--remove-arrow" container="body">
                        <span class="menu-icon" id="categorizationActionsDropdown" ngbDropdownToggle>
                            <i class="fas fa-ellipsis-v"></i>
                        </span>
                    <ul aria-labelledby="categorizationActionsDropdown" ngbDropdownMenu>
                        <li ngbDropdownItem (click)="onEdit(categorization)">
                            {{ t(disableEditing ? "app.common.view" : "app.common.edit") }}
                        </li>
                        @if (!disableEditing) {
                        <li ngbDropdownItem (click)="openDeleteCategorizationModal(categorization)">
                            {{ t("app.common.delete") }}
                        </li>
                        }
                    </ul>
                </div>
            </td>
        </tr>
        }
        </tbody>
  </table>
</div>
        } @else {
        <app-empty-state-admin/>
        }
    </div>
    <form [formGroup]="inputForm">
    <div #categoryForm="ngbCollapse" id="categoryForm" [(ngbCollapse)]="hideForm" class="mt-4"
         (shown)="navigateToForm()">
            <app-admin-card-with-title [cardTitle]="t(currentCategorization?.id ? 'league.scoring.categorization.edit' : 'league.scoring.categorization.add')" [removeTopMargin]="true"
                                       [showToggleButton]="true">
                <div class="row">
                    <div class="col-12 col-md-4 pt-3">
                        <app-input formControlName="name" label="app.common.name" formId="name"/>
                    </div>
                    <div class="col-12 col-md-4 pt-3">
                        <app-select
                                formControlName="individualScoringConfig"
                                [items]="individualScoringConfigs"
                                [labelKey]="'name'"
                                valueKey="id"
                                label="league.scoring.categorization.individual.config"
                        />
                    </div>
                    <div class="col-12 col-md-4 pt-3">
                        <app-select
                                formControlName="groupScoringConfig"
                                [items]="groupScoringConfigs"
                                [labelKey]="'name'"
                                valueKey="id"
                                label="league.scoring.categorization.group.config"
                        />
                    </div>
                </div>
                <div class="pt-4 pb-3 item-border-bottom">
                    <div class="d-flex justify-content-between align-items-center">
                                <span class="fw-semibold">{{ t("league.scoring.categorization.types") }}
                                </span>
                        <div class="pe-3">
                            @if (!disableEditing){
                            <app-rounded-button [label]="t('league.scoring.categorization.types.add')" (onClick)="addCategorizationType()"><i
                                    class="bi bi-plus-circle pe-2"></i></app-rounded-button>
                            }
                        </div>

                    </div>
                </div>
                <div formArrayName="types">
                    @if (typesArray.hasError('noTypes')) {
                     <p class="pt-4">
                        <ngb-alert [dismissible]="false" type="error-info">
                            {{t('league.scoring.categorization.noTypes.error')}}
                        </ngb-alert>
                     </p>
                    }
                    @if (typesArray.hasError('duplicateRace')) {
                      <p class="pt-4">
                        <ngb-alert [dismissible]="false" type="error-info">
                            {{t('league.scoring.categorization.duplicateRace.error')}}
                        </ngb-alert>
                       </p>
                    }
                    <div *ngFor="let typeCtrl of typesArray.controls; let i = index" [formGroupName]="i" class="mt-3">
                        <div class="row py-2 px-1">
                                    <div class="col-12 col-md-2 pt-3">
                                        <app-input formControlName="name" label="Type Name" formId="typeName{{i}}"/>
                                    </div>
                                    <div class="col-12 col-md-2 pt-3">
                                        <app-input formControlName="weightIndividual" label="league.scoring.categorization.types.weightIndividual" formId="weightInd{{i}}" type="number"/>
                                    </div>
                                    <div class="col-12 col-md-2 pt-3">
                                        <app-input formControlName="weightTeam" label="league.scoring.categorization.types.weightTeam" formId="weightTeam{{i}}" type="number"/>
                                    </div>
                                    <div class="col-md-5 col-12 pt-3">
                                        <div class="input-group d-flex flex-nowrap align-items-center">
                                            <div class="flex-grow-1">
                                                <app-tags-input [inputLabel]="t('league.scoring.categorization.types.assignedRaces')"
                                                                [tags]="typesFormControl(i).controls['assignedRacesTags'].value"
                                                                [isRequired]="typesFormControl(i).controls['assignedRaces'].errors?.['required']"
                                                                [showErrorMessage]="typesFormControl(i).controls['assignedRaces'].touched"
                                                                [errors]="typesFormControl(i).controls['assignedRaces'].errors"
                                                                (onTagRemoved)="onRemoveItem(i, $event)" [readonly]="true"
                                                                [cssClass]="'remove-border-right-radius'"/>
                                            </div>
                                            @if (!disableEditing) {
                                            <div class="info-box" (click)="openRaceSelection(i)">
                                                <i class="bi bi-info-circle bi-tag large-icon"></i>
                                            </div>
                                            }
                                        </div>
                                    </div>
                            @if (!disableEditing) {
                            <div class="col-1 d-md-flex d-none align-items-center justify-content-center pt-3">
                                <app-floating-icon-button
                                        iconClass="fas fa-trash-alt"
                                        (onClick)="deleteItemType(i)"
                                />
                            </div>
                            }

                </div>
                <div class="d-md-none d-flex pt-3 justify-content-end">
                    @if (!disableEditing) {
                            <app-rounded-button [label]="t('app.common.delete')" (onClick)="deleteItemType(i)"><i
                                    class="fas fa-trash-alt pe-2"></i></app-rounded-button>
                            }
                        </div>
                    </div>
                </div>

    </app-admin-card-with-title>
</div>
@if (!hideForm) {
        <app-action-buttons-row (onSave)="onSaveCategorization()" (onCancel)="onCancel()" [backVisible]="false" [cancelVisible]="true" [disableEditing]="disableEditing"></app-action-buttons-row>
        }
    </form>

</ng-container>
